import React, { useEffect, useState } from "react";
import styles from "./dashboard.module.css";
import Layout from "../../components/layout/layout";
import PduiDashboardBox from "./components/pdui_box/pdui_dashboard_box";
import { openModal } from "../../components/ajonjolib/toasts/toast/toast";
import ConfigurationModal from "./modals/configuration/configuration_modal";
import axiosInstance from "../../AxiosInstance";
import Loader from "../../components/loader/loader";
import { useTranslation } from 'react-i18next';

function DashboardHeader({ data }) {
  const { t } = useTranslation();
  const first_name = localStorage.getItem("first_name");
  return (
    <div className={styles.header}>
      <div>{t('dashboard.welcome', { name: first_name })}</div>
      <div className={"d-flex"}>
        <div
          className={styles.configureButton}
          onClick={() => {
            openModal("configuration_modal", data);
          }}
        >
          <img
            alt={"configure"}
            src={"/icons/config_button.png"}
            width={"20px"}
            height={"20px"}
          />
          <div className={"pt-2"}>
            {t('dashboard.configure')}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Dashboard() {
  const [data, setData] = useState([]);
  const [pduis, setPduis] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get("pdui/")
      .then((response) => {
        if (response?.status !== 200) {
          return;
        }
        const pduiData = response.data;
        setPduis(Array.isArray(pduiData) ? pduiData : pduiData.results || []);
      })
      .then(() =>
        axiosInstance.get("dashboard/detailed_list/").then((response) => {
          if (response?.status !== 200) {
            return;
          }
          const dashData = response.data;
          setData(Array.isArray(dashData) ? dashData : dashData.results || []);
        }),
      )
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className={styles.container}>
      {loading && <Loader />}
      <Layout selectedIndex={0}>
        <ConfigurationModal />
        <DashboardHeader data={pduis} />
        <div className={"d-flex flex-wrap"}>
          {data?.map((entry) => {
            return <PduiDashboardBox key={entry.id} data={entry} />;
          })}
        </div>
      </Layout>
    </div>
  );
}
